export default {
  isAuthenticated: false,
  token: '',
  claims: ''
};
